import { AdvancedSearchFieldSelectorModel } from "./../../models/advanced-search-field-selector";
import { AdvancedSearchFieldSelectorListView } from "./advanced-search-field-selector-list";
import { AdvancedSearchFieldSelectorView } from "./advanced-search-field-selector";
import { AdvancedSearchFilterGroupsView } from "./advanced-search-filter-groups";
import Marionette from "../../../shared/marionette-mustache";
import { AdvancedSearchFormModel } from "../../../search/models/advanced-search-form";
import { AdvancedSearchFilterModel } from "../../../search/models/advanced-search-filter";
import { FiltersCollection } from "../../../search/collections/filters";
import { backboneViewProperties } from "../../../decorators/backbone-properties";
import { AdvancedSearchFieldsView } from "../../../search/views/advanced-search/advanced-search-fields";
import { AdvancedSearchFiltersView } from "../../../search/views/advanced-search/advanced-search-filters";
import { UserSettingsModel } from "../../../settings/models/user-settings";
import { Container } from "aurelia-dependency-injection";

require("../../styles/advanced-search.less");
require("../../styles/advanced-search-filters.less");

const template = require<string>("../../../search/views/advanced-search/advanced-search-form.html");

const dom = {
    SEARCH_FILTERS: ".search-filters",
    CORE_FILTERS_DIV: ".core-filters",
    REPORT_FILTERS_DIV: ".report-filters",
    FIELDS_REGION: ".fields-region",
    FILTERS_REGION: ".filter-groups-region",
    ADVANCED_SEARCH_LOADING: "#advanced-search-loading",
    FILTER_DIVIDER: "hr.filters-divider",
    ADVANCED_SEARCH_CONTROLS: ".advanced-search-controls",
    FILTER_LABEL: ".filter-label",
    STANDARD_RESULTS_REGION: "#standard-results-region",
    NO_RESULTS_EXPLANATION_PANEL: ".no-results-explanation-panel",
    SELECT_ALL_CORES_BUTTON: ".select-all-cores",
    SELECT_ALL_REPORTS_BUTTON: ".select-all-reports",
    CORE_FILTERS: "input.core-filter",
    REPORT_FILTERS: "input.report-filter",
    SEARCH_FIELDS: "input.form-field",
    ADVANCED_FORM_MASK: ".advanced-form-mask",
    ADVANCED_FORM_MESSAGE_BOX: ".advanced-form-message-box",
    ADVANCED_FORM_MESSAGE: ".advanced-form-message",
    ADVANCED_SEARCH_RUN: "#advanced-search-run",
    FIELD_SELECTOR_REGION: ".field-selector-region",
    SUBSCRIPTION_ONLY_MESSAGE: "#searching-sub-message",
    DISABLE_SUB_SETTING: "#disable-sub-setting"
};
@backboneViewProperties({
    tagName: "div",
    template: template
})

export class AdvancedSearchFormView extends Marionette.LayoutView<AdvancedSearchFormModel> {

    private fieldsRegion: Marionette.Region;
    private fieldSelectorRegion: Marionette.Region;
    private filtersRegion: Marionette.Region;
    private userSettings: UserSettingsModel;

    constructor(options?) {
        super(options);
        this.userSettings = Container.instance.get(UserSettingsModel);
        this.listenTo(this.userSettings, "jurisdictionsChanged", this.updateFiltersJurisdictionsChanged);
    }

    public onShow() {
        this.setupSubViews();
        if (!this.model.AdvancedSearchEverOpened) {
            this.model.selectEnabledJurisdictions();
        }
        this.setStatusOfSubOnlyDisplayMessage();
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        events["click " + dom.DISABLE_SUB_SETTING] = (e) => this.disableSubSetting();
        return events;
    }

    public regions(): any {
        const regions: any = {
            fieldsRegion: dom.FIELDS_REGION,
            filtersRegion: dom.FILTERS_REGION,
            fieldSelectorRegion: dom.FIELD_SELECTOR_REGION
        };
        return regions;
    }

    public warningChanged(model, message) {
        if (this.model.WarningMessage) {
            $(dom.ADVANCED_FORM_MESSAGE_BOX).removeClass("search-error-message").addClass("warning-message");
            $(dom.ADVANCED_FORM_MESSAGE).text(this.model.WarningMessage);
            $(dom.ADVANCED_FORM_MESSAGE_BOX).show();
            $(dom.ADVANCED_FORM_MASK).show();
        } else {
            $(dom.ADVANCED_FORM_MESSAGE_BOX).hide();
            $(dom.ADVANCED_FORM_MASK).hide();
        }

        const fieldsEnabled = this.model.WarningMessage ? true : false; // not sure jquery prop() will coerce this to a boolean or not
        this.model.SearchFields.each((sf) => {
            if (this.model.WarningMessage) {
                sf.FieldValue = "";
            }
            $(`input[data-field-name="${sf.FieldName}"]`).prop("disabled", fieldsEnabled);
            $(`textarea[data-field-name="${sf.FieldName}"]`).prop("disabled", fieldsEnabled);
        });
    }

    private setupSubViews() {
        const fields = new AdvancedSearchFieldsView({collection: this.model.SearchFields});
        this.fieldsRegion.show(fields);

        if (this.model.SearchFilterGroups && this.model.SearchFilterGroups.length > 0) {
            const filters = new AdvancedSearchFilterGroupsView({collection: this.model.SearchFilterGroups});
            this.filtersRegion.show(filters);
        } else {
            this.$(dom.FILTERS_REGION).hide(); // Otherwise this was cauing a display issue in firefox due to it rendering as 1px wide block element
        }

        if (this.model.HasNotShownFields) {
            const fieldSelector = new AdvancedSearchFieldSelectorView(this.model.SearchFields, this.model.fieldSelectorModel);
            this.fieldSelectorRegion.show(fieldSelector);
        }
    }

    private updateFiltersJurisdictionsChanged() {
        this.setStatusOfSubOnlyDisplayMessage();
    }

    private setStatusOfSubOnlyDisplayMessage() {
        this.$(dom.SUBSCRIPTION_ONLY_MESSAGE).toggle(this.userSettings.SubscriptionOnly);
    }

    private disableSubSetting() {
        this.userSettings.SubscriptionOnly = false;
        _.defer(() => {
            this.userSettings.saveAndNotify();
        });
        this.setStatusOfSubOnlyDisplayMessage();
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/views/advanced-search/advanced-search-form.ts